import { render, staticRenderFns } from "./HistoryDetails.vue?vue&type=template&id=40cfe2a5&scoped=true"
import script from "./HistoryDetails.vue?vue&type=script&lang=js"
export * from "./HistoryDetails.vue?vue&type=script&lang=js"
import style0 from "./HistoryDetails.vue?vue&type=style&index=0&id=40cfe2a5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40cfe2a5",
  null
  
)

export default component.exports